import { useFindByQuery } from '../../graphql';

export const useGroupProductAlerts = (
  entityType: 'group' | 'product',
  entityId: string
) => {
  const filter: any = {
    action: { type: { eq: 'ALERT' } },
    disabled: { ne: true },
  };

  if (entityType === 'group') {
    filter.group = { eq: entityId };
  } else {
    filter.product = { eq: entityId };
  }

  const { data, isLoading, refetch } = useFindByQuery({
    modelName: 'workflow',
    query: FIND_ENTITY_WORKFLOWS,
    variables: {
      filter,
      page: { limit: 10000, offset: 0 },
    },
    options: { enabled: !!entityId },
  });

  return {
    workflows: data?.items || [],
    isLoading,
    refetch,
  };
};

const FIND_ENTITY_WORKFLOWS = `
  query FindEntityWorkflows($filter: WorkflowFilter, $page: PageRequest) {
    findWorkflows(filter: $filter, page: $page) {
      items {
        id
        name
        trigger {
          type
          config
        }
        action {
          type
          config
        }
        disabled
        createdAt
      }
    }
  }
`;
